import type {
  IResponseApi,
  IResponseApiSearch
} from '@/modules/Core/interfaces/api/IApis'
import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
import type { ICitaOrdenes } from '@/modules/Asistencial/interfaces'
import type { ICitaOrdenesTecnologia } from '@/modules/Admision/interfaces/tablas/ICitaOrdenesTecnologia'
import type { IEntidadesProfesionalesExternasResponse } from '@/modules/Admision/interfaces'
export class AsistencialOrdenesService extends BaseService<ICitaOrdenes | ICitaOrdenesTecnologia> {
  constructor () {
    super({
      baseUrl: 'scheduling/assistance-orders/'
    })
  }
  async listOrdenes<T> (
    tipo: string,
    id: number,
    params?: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<T[]>>> {
    return this.http.get<IResponseApi<T[]>>(`/list/${tipo}/${id}`, { params })
  }

  // Buscar elementos con parámetros
  async searchOrdenes<T> (
    tipo: string,
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApiSearch<T[]>>> {
    return this.http
      .get<IResponseApiSearch<T[]>>(`/search/${tipo}`, { params })
      .catch(this.errorHandle)
  }

  // Ver un elemento por ID
  async viewOrdenes<T> (
    tipo: string,
    id: number | string | string[]
  ): Promise<AxiosResponse<IResponseApi<T>>> {
    return this.http.get<T>(`/view/${tipo}/${id}`).catch(this.errorHandle)
  }

  // Crear un nuevo elemento
  async saveOrdenes<T> (
    tipo: string,
    id: number,
    data: T
  ): Promise<AxiosResponse<IResponseApi<T>>> {
    return this.http.post<T>(`/save/${tipo}/${id}`, data).catch(this.errorHandle)
  }
  // Crear un nuevo elemento
  async createOrdenes<T> (
    tipo: string,
    data: T
  ): Promise<AxiosResponse<IResponseApi<T>>> {
    return this.http.post<T>(`/create/${tipo}`, data).catch(this.errorHandle)
  }

  // Crear varios diagnosticos en bulk (add-only, no borra existentes)
  async createDiagnosticosBulk<T> (
    data: T[]
  ): Promise<AxiosResponse<IResponseApi<T[]>>> {
    return this.http.post<T[]>(`/bulk/diagnostico`, data).catch(this.errorHandle)
  }

  // Actualizar un elemento por ID
  async updateOrdenes<T> (
    tipo: string,
    id: number | string,
    data: Partial<T>
  ): Promise<AxiosResponse<IResponseApi<T>>> {
    return this.http
      .put<T>(`/update/${tipo}/${id}`, data)
      .catch(this.errorHandle)
  }

  // Eliminar un elemento por ID
  async deleteOrdenes (
    tipo: string,
    id: number | string
  ): Promise<AxiosResponse<IResponseApi<void>>> {
    return this.http.delete<void>(`/delete/${tipo}/${id}`).catch(this.errorHandle)
  }

  async getEntidadesProfesionalesExternas (): Promise<AxiosResponse<IResponseApi<IEntidadesProfesionalesExternasResponse>>> {
    return this.http
      .get<IResponseApi<IEntidadesProfesionalesExternasResponse>>(`/entidades-profesionales-externas`)
      .catch(this.errorHandle)
  }
}
